import { NgModule } from '@angular/core';
import { CompatABTestComponent } from './compat-abtest.component';

@NgModule({
  declarations: [CompatABTestComponent],
})
export class CompatABTestModule {}
